import axios from "../../datasource/axios";

import { hideLoader, showLoader } from "../../datasource/msal";
import {
  DROPDOWNVALUES_URL,
  CONTRACTEDBYCOUNTRY_URL,
  FILTERSEGMENTATTRIBUTES_URL,
  FILTERTOTALCLIENTSBYMANAGER_URL,
  GetParentAndUltimateClient_URL,
  GETDROPDOWNTABLELIST_URL,
  LEGALENTITYMAPPINGS_URL,
  GETTIMEZONELIST_URL,
  GETBUSINESSSEGMENTLIST_URL,
  ADMINDROPDOWNVALUES_URL,
  GETCHANNELLIST_URL,
  GETPARENTCLIENTSTARTDATE_URL
} from "../../constants";

export const getDropdownValues = (tableName?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + DROPDOWNVALUES_URL + "?tableName=" + tableName;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getAdminDropdownValues = (tableName?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + ADMINDROPDOWNVALUES_URL + "?tableName=" + tableName;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getDropdownList = () => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + GETDROPDOWNTABLELIST_URL;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getTimezoneDropdownList = () => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + GETTIMEZONELIST_URL;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getChannelDropdownList = () => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + GETCHANNELLIST_URL;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getBusinessSegmentDropdownList = () => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + GETBUSINESSSEGMENTLIST_URL;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getContractedByCountry = (legalEntity?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + CONTRACTEDBYCOUNTRY_URL + "?legalEntity=" + legalEntity;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getLegalEntityMappings = () => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + LEGALENTITYMAPPINGS_URL;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getFilteredTotalClientsByManager = (segment?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + FILTERTOTALCLIENTSBYMANAGER_URL + "?segment=" + segment;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getFilteredSegmentAttributes = (segment?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + FILTERSEGMENTATTRIBUTES_URL + "?segment=" + segment;

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getparentandultimateclientAttributes = (type?: string, id?: string) => {
  let BASE_URL =  process.env.REACT_APP_API_URI;
  let url = BASE_URL + GetParentAndUltimateClient_URL + "?clienttype=" + type + "&code=" + id;
  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getParentClientStartDate = (clientName: string) => {
  let BASE_URL = process.env.REACT_APP_API_URI;
  let url = BASE_URL + GETPARENTCLIENTSTARTDATE_URL + "?clientName=" + encodeURIComponent(clientName);

  return new Promise((resolve, reject) => {
    try {
      axios
        .getRequest(url)
        .then((res: any) => {
          hideLoader();
          resolve(res.data);
        })
        .catch((err: any) => {
          resolve(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};